import { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FlashcardSet } from '@/lib/types/flashcard';
import { FlashcardCard } from './flashcard-card';

interface FlashcardDisplayProps {
  data: FlashcardSet;
}

export function FlashcardDisplay({ data }: FlashcardDisplayProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < data.cards.length - 1 ? prev + 1 : prev));
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <p className="text-sm text-gray-500 dark:text-dark-muted">
          Card {currentIndex + 1} of {data.totalCards}
        </p>
      </div>

      <div className="relative mx-auto max-w-2xl">
        <div className="absolute inset-y-0 left-0 flex items-center">
          <Button
            variant="outline"
            size="sm"
            onClick={handlePrevious}
            disabled={currentIndex === 0}
            className="h-12 w-12 rounded-full"
          >
            <ChevronLeft className="h-6 w-6" />
          </Button>
        </div>

        <div className="px-16">
          {data.cards.map((card, index) => (
            <FlashcardCard
              key={card.id}
              card={card}
              isActive={index === currentIndex}
            />
          ))}
        </div>

        <div className="absolute inset-y-0 right-0 flex items-center">
          <Button
            variant="outline"
            size="sm"
            onClick={handleNext}
            disabled={currentIndex === data.cards.length - 1}
            className="h-12 w-12 rounded-full"
          >
            <ChevronRight className="h-6 w-6" />
          </Button>
        </div>
      </div>

      <div className="text-center">
        <p className="text-sm text-gray-500 dark:text-dark-muted">
          Click card to flip
        </p>
      </div>
    </div>
  );
} 